import moment from "moment-jalali";
import { useEffect, useState } from "react";
import { Button, Col, Form, FormGroup, Modal, Row } from "react-bootstrap";
import { create, getNextNumber, getWorkItemsBaseInfoes } from "../store/api/workItemsApi";
import { useDispatch } from "react-redux";
import WorkItemRefer from "../Components/WorkItemRefers/WorkItemRefer";
import Loader from "react-loader-spinner";
import { CheckLg, Toggles2 } from "react-bootstrap-icons";
import { convertFromMoment, setErrorDialog, workItemSeverity, workItemTypes } from "../../store/api/CommonFunctions";
import Checklist from "../../Components/CheckList/Checklist";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusSquare, faTimes } from "@fortawesome/free-solid-svg-icons";
import NewRefer from "../Components/WorkItemRefers/NewRefer";
import ModalNewRefer from "../Components/WorkItemRefers/ModalNewRefer";

export default function ModalCreateEditWorkItems({ modalData, setModalData }) {
    const dispatch = useDispatch();
    const [pendingGet, setPendingGet] = useState(false);
    const [baseInfoes, setBaseInfoes] = useState(null);
    const [pendingSubmit, setPendingSubmit] = useState(false);
    const initData = {
        CreationDate: moment().local("en").format("YYYY-MM-DD"),
        PCreationDate: moment().local("fa").format("jYYYY/jMM/jDD"),
        Type: workItemTypes.task,
        Severity: workItemSeverity.medium,
        Priority: 2,
        Type: workItemTypes.task
    }
    const [workItemData, setWorkItemData] = useState({ ...initData });
    function handleUpdateCheckList(item) {
        setWorkItemData(prev => {
            let checkList = [...prev.CheckList ?? []];
            checkList = checkList.map((ch) => ch.ID.toString() === item.id.toString() ? { ...ch, Title: item.text } : ch);
            return { ...prev, CheckList: checkList };
        });
    }
    function handleRemoveCheckList(item) {
        setWorkItemData(prev => {
            let checkList = [...prev.CheckList ?? []];
            checkList = checkList.filter((ch) => ch.ID.toString() !== item.id.toString());
            return { ...prev, CheckList: checkList };
        });
    }
    async function handleAddCheckList(item) {
        const wiCheck = { Title: item.text, IsDone: false, SortOrder: 0, ID: item.id };
        setWorkItemData(prev => {
            let checkList = [...prev.CheckList ?? []];
            checkList.push(wiCheck);
            checkList = checkList.map((ch) => ch.ID.toString() === item.id.toString() ? { ...ch, IsDone: item.done } : ch);
            return { ...prev, CheckList: checkList };
        });

    }
    async function handleSubmitWorkItem() {
        if (pendingSubmit) {
            return;
        }
        /********************************* data *************************/
        workItemData.StartDate = convertFromMoment(workItemData.StartDate).date;
        workItemData.AlarmDate = convertFromMoment(workItemData.AlarmDate).date;
        workItemData.DueDate = convertFromMoment(workItemData.DueDate).date;
        workItemData.CompletedDate = convertFromMoment(workItemData.CompletedDate).date;
        workItemData.Links = [{
            EntityID: modalData.entityId,
            EntityGroupType: modalData.entityGroupType ?? modalData.entityType,
            EntityType: modalData.entityType
        }];
        workItemData.Labels = workItemData.Labels;
        workItemData.CheckList = workItemData.CheckList;
        if (workItemData.ReferInfo) {
            workItemData.ReferInfo.Priority = workItemData.Priority;
            if (!workItemData.ReferInfo.ReferDescription) {
                workItemData.ReferInfo.ReferDescription = modalData.title;
            }
        }
        workItemData.CheckList?.forEach(c => {
            if (isNaN(c.ID)) {
                c.ID = 0;
            }
        }
        )
        /********************************* submit ************************/
        let result = null;
        setPendingSubmit(true);
        result = await create(workItemData);
        setPendingSubmit(false);
        /********************************* result ************************/
        if (result == null) {
            setErrorDialog(dispatch, "خطای ناشناخته", "ثبت/ویرایش اطلاعات");
        }
        else if (result.Message) {
            setErrorDialog(dispatch, result.Message, "ثبت/ویرایش اطلاعات");
        }
        else if (result.Data) {
            setErrorDialog(dispatch, "Success", "ثبت/ویرایش اطلاعات");
            if (result.Data.CheckList?.length > 0) {
                result.Data.TempCheckList = result.Data.CheckList.map(d => (
                    {
                        text: d.Title,
                        id: d.ID,
                        done: d.IsDone,
                        doneDate: d.PDoneDate,
                        doneByName: d.DoneByName,
                        doneComment: d.DoneComment
                    }));
            }
            setWorkItemData({ ...initData });
            setModalData({ show: false });
        }
    }
    const handleRefer = (data) => {
        setWorkItemData(prev => ({ ...prev, ReferInfo: { ...prev.ReferInfo, ...data } }));
    }
    async function getInfoes() {
        setBaseInfoes("PENDING");
        const result = await getWorkItemsBaseInfoes();
        if (result?.Data) {
            setBaseInfoes(result.Data);
        }
    }
    useEffect(() => {
        if (modalData.show) {
            getInfoes();
            setWorkItemData(prev => ({ ...prev, Title: modalData.title }));
        }
    }, [modalData.show])
    return (
        <Modal size="xl" show={modalData.show}>
            <Modal.Header className="headerStyle">
                <span>
                    <FontAwesomeIcon icon={faPlusSquare} size="lg" />&nbsp;وظیفه جدید
                </span>
                <FontAwesomeIcon icon={faTimes} size="lg" onClick={() => setModalData({ show: false })} />
            </Modal.Header>
            <Modal.Body className="bodyStyle">
                <Row>
                    <Col md={3} className="form-group">
                        <label>نوع:</label>
                        <select className="form-control" name="Type" defaultValue={workItemTypes.task}
                            onChange={e => setWorkItemData(prev => ({ ...prev, Type: e.target.value }))}>
                            <option value="">انتخاب کنید</option>
                            <option value={workItemTypes.bug}>باگ</option>
                            <option value={workItemTypes.changeRequest}>درخواست تغییر</option>
                            <option value={workItemTypes.feature}>امکان جدید</option>
                            <option value={workItemTypes.improvement}>بهینه‌سازی</option>
                            <option value={workItemTypes.task}>وظیفه</option>
                        </select>
                    </Col>
                    <Col md={3} className="form-group">
                        <label>دسته‌بندی:</label>
                        {
                            baseInfoes == "PENDING" ?
                                <div className="form-control">
                                    <Loader type="BallTriangle" width={21} height={21} color="#bb1370" style={{ display: "inline-block" }} />&nbsp;
                                    در حال بارگذاری فهرست...
                                </div> :
                                <select className="form-control" name="CategoryID" >
                                    <option value="">انتخاب کنید</option>
                                    {Array.isArray(baseInfoes?.CategoryList) &&
                                        baseInfoes.CategoryList.map((s, i) =>
                                            <option key={i} value={s.ID}>{s.InfoName}</option>)
                                    }
                                </select>
                        }
                    </Col>
                    <Col md={3} className="form-group">
                        <label>اهمیت:</label>
                        <select className="form-control" name="Severity" defaultValue={workItemSeverity.medium}>
                            <option value={workItemSeverity.critical}>فوری</option>
                            <option value={workItemSeverity.major}>زیاد</option>
                            <option value={workItemSeverity.medium}>متوسط</option>
                            <option value={workItemSeverity.minor}>کم</option>
                            <option value={workItemSeverity.trivial}>بسیار پایین</option>
                        </select>
                    </Col>
                    <Col md={3} className="form-group">
                        <label>اولویت:</label>
                        <select className="form-control" name="Priority" defaultValue={2}>
                            <option value={4}>بسیار بالا</option>
                            <option value={3}>بالا</option>
                            <option value={2}>نرمال</option>
                            <option value={1}>پایین</option>
                        </select>
                    </Col>
                </Row>
                <Row className="rowBorder mt-3">

                    <div className="rowTitle">موضوع(هدف وظیفه)</div>
                    <FormGroup>
                        <Form.Control as="textarea" cols={2} name="Title" defaultValue={modalData.title ?? ""} onChange={e => setWorkItemData(prev => ({ ...prev, Title: e.target.value }))} />
                    </FormGroup>
                </Row>
                <Checklist
                    initialItems={[]}
                    title="چک لیست"
                    classNames="custom-checklist-container1"
                    onAdd={handleAddCheckList}
                    onUpdate={handleUpdateCheckList}
                    onRemove={handleRemoveCheckList}
                />
                {workItemData?.Type &&
                    <Row className="rowBorder">
                        <div className="rowTitle">ارجاع به کاربر:</div>
                        <ModalNewRefer onDataChange={handleRefer} defaultReferDesc={modalData.title} />
                    </Row>}
                <div className="d-flex gap-1">
                    <Button variant="success" type="submit" disabled={pendingSubmit} className="mt-1 group-Btn-large" onClick={handleSubmitWorkItem}>
                        {pendingSubmit ?
                            <Loader type="TailSpin" color="white" width={16} height={16} style={{ display: "inline-block" }} /> :
                            <CheckLg size={21} />
                        }&nbsp;
                        ثبت وظیفه
                    </Button>
                </div>

            </Modal.Body>
        </Modal>
    )
}